// hide checkbox field form_input_Toe_Kick_FE_Left when  include_leg_levelers_input is checked

(function () {
    var include_leg_levelers = jQuery("#include_leg_levelers_input");
    var left_leg = jQuery("#form_input_Toe_Kick_FE_Left");
    var right_leg = jQuery("#form_input_Toe_Kick_FE_Right");

    include_leg_levelers.change(function () {
        if (include_leg_levelers.is(":checked")) {
            left_leg.show();
            right_leg.show();
        } else {
            left_leg.hide();
            right_leg.hide();
            //uncheck left and right
            left_leg.find('input[type="checkbox"]').prop('checked', false);
            right_leg.find('input[type="checkbox"]').prop('checked', false);
        }
    }
    );
}
)();

